/* eslint-disable react/prop-types */
import React, { useEffect, useId, useState } from 'react';

import { type NextPage } from 'next';
import { type NextFont } from 'next/dist/compiled/@next/font';

import { PageContainer, Editions } from '../components/index';
import { type IEditionsProps } from '../components/Editions';
import { Loading } from '../components/util';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useGetAllParticipantsMutation } from '../utils/services/EditionsApiConnection';
import { Button } from '../components/ui/button';
import { useInView } from 'react-intersection-observer';

// eslint-disable-next-line react/prop-types
const Celebrated: NextPage<{ inter: NextFont }> = ({ inter }) => {
  const { ref: loadMoreRef, inView: loadMoreInView } = useInView({
    threshold: 0,
  });
  const [celebratedTechies, setCelebratedTechies] = useState<
    Array<Partial<IEditionsProps>>
  >([]);
  const [index, setIndex] = useState<number>(0);
  // const { data, isLoading } = useGetCelebratedTechiesQuery({}) as {
  //   data: { data: IEditionsProps[] }
  //   isLoading: boolean
  // };
  const [getParticipants, { data: winnersData, isLoading: isWinnersLoading }] =
    useGetAllParticipantsMutation();
  useEffect(() => {
    if (loadMoreInView && !isWinnersLoading && index !== winnersData?.last_page) {
      setIndex((winnersData?.current_page ?? 0) + 1);
      getParticipants((winnersData?.current_page ?? 0) + 1);
    }
  }, [loadMoreInView, isWinnersLoading]);
  useEffect(() => {
    if (
      winnersData?.data &&
      index === winnersData?.current_page &&
      !isWinnersLoading
    ) {
      setCelebratedTechies((prev) => [...prev, ...winnersData.data]);
    }
  }, [winnersData]);
  return (
    <PageContainer>
      <div
        className={`content mt-12 flex flex-col items-center ${inter.className}`}
      >
        <h1 className="text-center text-2xl font-bold text-[#0c0114] lg:text-3xl">
          The Celebrated Techies
        </h1>
        <p className="text-center text-2xl font-medium text-[#808080] lg:text-xl">
          Exploring Our Past Contestants
        </p>
        <div className="mt-2 flex flex-col gap-6">
          <div className="grid grid-cols-1 gap-12 p-6 md:grid-cols-2 md:p-8 lg:grid-cols-4 lg:p-12">
            {celebratedTechies?.map((props) => (
              <Editions key={props.Id} {...props} />
            ))}
          </div>
          {isWinnersLoading ? (
            <Loading className="my-5" />
          ) : index !== winnersData?.last_page ? (
            <Button
              variant="secondary"
              ref={loadMoreRef}
              className="mx-auto my-5 w-fit px-6 py-6 text-lg opacity-0"
            >
              Load More
            </Button>
          ): (
            <p className="text-center text-3xl font-medium text-[#808080] lg:text-xl my-2">
              No More Participants
            </p>
          )}
        </div>
      </div>
    </PageContainer>
  );
};

export default Celebrated;
